/* eslint-disable react-hooks/exhaustive-deps */

import React, { useContext, useEffect } from "react";
import { TableRow, TableCell, Paper } from "@material-ui/core";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import {
  IconButtonDatatable,
  SearchInput,
  DatatablesFooterServerSide,
  Loading,
} from "App/Component/ui";
import { useDatatables, useDatatablesServerSide } from "App/hooks";
import { headCells } from "./helpers";
import { SelectIcon } from "App/Assets";
import { formatNumber, isNull } from "App/utils/helpers";
import { FormContext } from "../../../context/FormContext";
import { FreezeTable } from "components/organism";
import { useDebounce } from "hooks";

export default function DaftarJasa({
  rows,
  handleClickSelect,
  setFormFilterJasaByKelas,
  formFilterJasaByKelas,
  totalData,
  setNewDataJasaByKelas,
  loading,
}) {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "namaMsJasa",
    orderByRow: ["namaMsJasa"],
  });

  const { formData } = useContext(FormContext);

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewDataJasaByKelas });
  const debounceSearchInput = useDebounce(formFilterJasaByKelas.name, 300);

  const handleSearchInput = () => {
    if (!isNull(formFilterJasaByKelas.name)) {
      setNewDataJasaByKelas(
        formFilterJasaByKelas.pages,
        formFilterJasaByKelas.limit,
        {
          name: formFilterJasaByKelas.name,
        }
      );
    } else {
      setNewDataJasaByKelas(
        formFilterJasaByKelas.pages,
        formFilterJasaByKelas.limit,
        {
          name: null,
        }
      );
    }
  };

  useEffect(() => {
    handleSearchInput();
  }, [debounceSearchInput]);

  return (
    <>
      <Paper
        style={{
          padding: "1rem",
        }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}>
          <p className='fw-600 fs-14'>Daftar Jasa</p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
            }}>
            <div>
              <SearchInput
                withIcon={true}
                heightInput='0.4'
                onchange={(e) => {
                  setFormFilterJasaByKelas((prev) => {
                    return {
                      ...prev,
                      name: e.target.value,
                    };
                  });
                }}
              />
            </div>
          </div>
        </div>
        <Loading show={loading} />
        <div className='mt-1'>
          <FreezeTable
            headCells={headCells}
            handleRequestSort={handleRequestSort}
            order={order}
            length={length}
            maxHeight='400px'
            orderBy={orderBy}>
            {stableSort(rows, getComparator(order, orderBy)).map(
              (row, index) => {
                return (
                  <TableRow hover key={index}>
                    <TableCell
                      scope='row'
                      padding='none'
                      width='5%'
                      align='center'>
                      {index + 1}
                    </TableCell>

                    <TableCell
                      scope='row'
                      width='10%'
                      padding='none'
                      align='center'>
                      {!formData.is_lock && !formData.is_close && (
                        <IconButtonDatatable
                          color='secondary'
                          aria-label='delete'
                          onClick={() => handleClickSelect(row)}
                          style={{
                            background: "#D8D8D8",
                            padding: "5px 4px",
                          }}>
                          <SelectIcon
                            width={"14"}
                            height={"14"}
                            fill={"#fff"}
                          />
                        </IconButtonDatatable>
                      )}
                    </TableCell>
                    <TableCell align='left' width='5%'>
                      {row?.id_jasa}
                    </TableCell>
                    <TableCell align='left'>{row?.namaMsJasa}</TableCell>
                    <TableCell align='right' width='10%'>
                      {formatNumber(row?.harga_jual)}
                    </TableCell>
                    <TableCell align='left' width={"30%"}>
                      {row?.namaJsJasa}
                    </TableCell>
                  </TableRow>
                );
              }
            )}
            {rows.length === 0 && (
              <TableRow>
                <TableCell align='center' colSpan={headCells.length}>
                  Tidak ada data
                </TableCell>
              </TableRow>
            )}
          </FreezeTable>
          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </div>
      </Paper>
    </>
  );
}
